import { Component, OnInit } from '@angular/core';
import { $BroadcastManagerService } from '../../BroadcastManager.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalData } from '../ModalData';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-modal-success',
    templateUrl: 'modal.success.html',
    styleUrls: ['./modal.success.css']
})
export class ModalSuccessComponent {
    public modalDataObj: ModalData;

    constructor(
        public bsModalRef: BsModalRef,
        private $: $BroadcastManagerService,
        private router: Router
    ) { }

    emitEv(title: any): void {
        console.log("title  -------",title);
        if(title == "Entity Registration"){
            this.router.navigateByUrl('/common-login');
            this.$.emit({
                click: 'ok'
            });
            this.bsModalRef.hide();
        }
        else{
        this.$.emit({
            click: 'ok'
        });
        this.bsModalRef.hide();
    }

    }
}